/* eslint-disable css-modules/no-unused-class */
import { FC } from 'react';
import classNames from 'classnames';
import { Divider, Icon } from 'common-components';
import styles from './editorHeader.module.scss';
import { HeaderVariant } from '../customEditorTypes';
import { useTranslationContext } from '../../contexts/translationContext';

const EditorHeader: FC<EditorHeaderProps> = (props: EditorHeaderProps) => {
    const { styleVariant, userLogo, completedMask, headerActions, userNickname } = props;

    const { translate } = useTranslationContext();

    const getFirstLetters = (input: string): string => {
        const words = input.split(' ').filter(word => word.length > 0);
        if (words.length === 0) return '';
        if (words.length === 1) return words[0].charAt(0).toUpperCase();
        return words[0].charAt(0).toUpperCase() + words[1].charAt(0).toUpperCase();
    };

    const variantProps = {
        [HeaderVariant.VULNERABLE]: {
            title: translate('VulnerableCode'),
            info: translate('Attack'),
            logo: (
                <div className={styles['logo-wrapper']}>
                    <div className={styles['bg-wrapper']}>
                        <Icon name="errorBoxBG" isPng={true} />
                    </div>
                    <span>{'</>'}</span>
                </div>
            )
        },
        [HeaderVariant.REMEDIATION]: {
            title: translate('RemediationPanel'),
            info: translate('YourIDE'),
            logo: userLogo ? (
                <div className={styles['logo-wrapper']} style={{ background: `url('${userLogo}')` }} />
            ) : (
                <div className={styles['logo-wrapper']}>{getFirstLetters(userNickname)}</div>
            )
        }
    };

    return (
        <div className={classNames(styles.container, styles[styleVariant])}>
            <div className={styles.wrapper}>
                <div className={styles['title-wrapper']}>
                    <span className={styles.title}>{variantProps[styleVariant].title}</span>
                    {completedMask && (
                        <div className={styles.subtitle}>
                            <Divider
                                orientation="vertical"
                                className={styles.divider}
                                color="rgba(255, 255, 255, 0.25)"
                            />
                            <span>{translate('ReadOnly')}</span>
                        </div>
                    )}
                    {headerActions?.()}
                </div>
                <div className={styles['info-wrapper']}>
                    <span>{variantProps[styleVariant].info}</span>
                    {variantProps[styleVariant].logo}
                </div>
            </div>
        </div>
    );
};

interface EditorHeaderProps {
    styleVariant: HeaderVariant;
    userLogo?: string;
    completedMask?: boolean;
    headerActions?: Function;
    userNickname: string;
}

export default EditorHeader;
